module.exports = __webpack_public_path__ + "static/media/sales.2d7c9f0d.svg";